import request from '@/utils/request'; // 广告数据回传展示

export function getAdvMsg(data) {
  return request({
    url: '/data/advertising_max_data',
    method: 'get',
    params: data
  });
}